/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


import descriptor from 'solis/claude/action/descriptor/create.influence';
import ActionCard from 'solis/claude/action/card';
import Field from 'solis/claude/action/field';

import ZoneInfluences from 'solis/logic/board/zone/influences';

import ActionSlider from 'solis/claude/action/input/slider';


// Children evaluate before ActionCard gates on availability, so the bounds must
// tolerate a missing source colony or target zone.
const getExistingValue = (sourceColony, zone) =>
{
  if (sourceColony === null || zone === null)
  {
    return 0;
  }

  return zone.getInfluence(sourceColony.cass.id)?.cass.value ?? 0;
};


const getUserValue = (account, zone) =>
{
  if (account === null || zone === null)
  {
    return 0;
  }

  return new ZoneInfluences(zone).getUserInfluenceValue(account.cass.id);
};


export default ({ context }) =>
{
  const existing = getExistingValue(context.sourceColony, context.zone);
  const userValue = getUserValue(context.account, context.zone);

  const min = existing;
  const max = Math.min(existing + (context.sourceColony?.cass.currentInfluence ?? 0), context.board.getSettings().getInfluenceMaxValue() - (userValue - existing));

  return (
    <ActionCard label = 'Create influence' descriptor = {descriptor} context = {context}>

      <Field label = 'Value'>
        <ActionSlider scope = {descriptor.scope} name = 'value' initial = {descriptor.inputs.value} min = {min} max = {max} />
      </Field>

    </ActionCard>
  );
};
